import React, { Component } from "react";
import { observer } from "mobx-react";
import { select_addr_forkakao_detail_check } from "../../../../../http/kakaoConn";
import { select_addr_fornaver, select_addr_fornaver_detail_check } from "http/addrConn"
import { fn_add_box_show } from "../../../../../function/FnBodyLayer";


@observer
class AddressSearchViewItem extends Component {
    constructor(props) {
        super(props);
        this.addressScrollSet = props.addressScrollSet.bind(this); 
    }

    render() {
        const { rootStore, addr } = this.props;

        return (

            <li className={addr.click_obj ? "on" : ""}>
                <button
                    onClick={event => {
                        //naver
                        if (rootStore.viewStore.getAddrApiName.api === "naver") {
                            select_addr_fornaver_detail_check(rootStore, "list", addr.address, addr.roadAddress).then(r => {
                                rootStore.viewStore.setSearchAddrClickObj(addr.address, addr.id);   // 선택한 주소 on표시
                                fn_add_box_show(rootStore, true);
                            })
                        } else {
                            document.getElementById("addAdress").value = addr.place_name;
                            rootStore.viewStore.setSearchAddrClickObj(addr.address, addr.id);   // 선택한 주소 on표시
                            rootStore.viewStore.setSelectedAddr(addr);      // 선택한 주소 view객체에 담기
                            rootStore.viewStore.setKakaoMap(addr.y, addr.x)
                            fn_add_box_show(rootStore, true);
                            select_addr_fornaver_detail_check(rootStore, "list", addr.address, addr.roadAddress).then(r => {
                            })
                        }
                        
                        rootStore.viewStore.setClickedAddress(addr.address)
                        //목록 스크롤 위치 다시 지정.(마우스휠 이동할 경우 대응)
                        let addressArea = document.getElementById("addressListElement")
                        this.addressScrollSet(addressArea.scrollTop)
                    }}
                >
                    <span className="address">{addr.address}</span>
                    <span className="road_name">(도로명) {addr.roadAddress}</span>
                </button>
            </li>
        );
    }
}

export default AddressSearchViewItem;